import Checkout from "features/checkout/containers/Checkout";
import React from "react";

const CheckoutComponent = () => {
  return <Checkout />;
};

export default CheckoutComponent;
